import jsPDF from "jspdf";
import modelo from "./modelo-data";

export function crearPDF(m) {
  const pdf = new jsPDF({ unit: "pt", format: [612.12, 1008.12], compress: true });
  const c = m.snapshot?.configuracion || {}, d = m.datos || {};
  pdf.addImage(modelo, "PNG", 0, 0, 612.12, 1008.12);
  pdf.setFont("helvetica", "normal");
  // Durante el piloto se dejan visibles los desbordes para ajustar el modelo.
  const field = (value, x, y, width, height, clear = false, size = 8) => {
    if (clear) {
      pdf.setFillColor(255);
      pdf.rect(x, y, width, height, "F");
    }
    if (value === undefined || value === null || value === "") return;
    pdf.setFontSize(size);
    let lines = pdf.splitTextToSize(String(value), width - 4);
    // Ajusta las filas compactas sin ocultar los desbordes del piloto.
    while (lines.length * size * 1.1 > height - 1 && size > 4) {
      size = Math.max(4, size - 0.25);
      pdf.setFontSize(size);
      lines = pdf.splitTextToSize(String(value), width - 4);
    }
    const textHeight = lines.length * size * 1.1;
    pdf.text(lines, x + 2, y + (height <= 18 ? Math.max(0, (height - textHeight) / 2) : 0) + size,
      { lineHeightFactor: 1.1 });
  };
  if (c.organismo && c.organismo !== "Programa Gestión Ambiental") {
    field(c.organismo, 12, 23, 200, 21, true, 11);
    field(c.organismo, 110, 166, 432, 13, true, 9);
  }
  if (c.referencia && c.referencia !== "CDE. RESOLUCIÓN N° 61-PGA-2014")
    field(c.referencia, 333, 94, 239, 28, true, 11);
  if (c.normativa && c.normativa !== "Ley Nº IX-0335-2004, Decreto Nº 2092-MLyRI-2006")
    field(c.normativa, 111, 212, 226, 28, true, 9);
  if (c.declaracion && c.declaracion !== "Declaro bajo juramento que la información y datos manifestados en el presente son veraces y se ajustan a la legislación vigente en la materia")
    field(c.declaracion, 110, 835.5, 432, 18, true, 7);
  pdf.setFillColor(255);
  pdf.rect(456, 210, 85, 30, "F");
  if (m.numero) field(`Nº ${m.numero}`, 456, 210, 85, 30, false, 9);
  const roles = ["Generador", "Transportista", "Operador"];
  roles.forEach((rol, i) => {
    const s = m.snapshot?.[rol] || {}, x = [216, 324, 438][i], width = [105, 111, 104][i];
    if (i === 0) {
      pdf.setFillColor(255);
      for (let row = 0; row < 4; row++) pdf.rect(x, 283.7 + row * 13.4, width, 12.4, "F");
    }
    if (s.caa || s.vencimiento) {
      pdf.setFillColor(255);
      pdf.rect(x, 337.8, width, 11.3, "F");
    }
  });
  roles.forEach((rol, i) => {
    const s = m.snapshot?.[rol] || {}, x = [216, 324, 438][i], width = [105, 111, 104][i];
    ["razonSocial", "domicilio", "legajo", "cuit"].forEach((key, row) =>
      field(s[key], x, 283.7 + row * 13.4, width, 12.4)
    );
    if (s.caa || s.vencimiento)
      field(`Nº ${s.caa || ""}  Vto: ${s.vencimiento || ""}`, x, 337.8, width, 11.3, false, 6.5);
  });
  const vehicle = m.intervenciones?.find((i) => i.accion === "TRASLADO")?.vehiculo || m.snapshot?.vehiculo || d.vehiculo;
  [[vehicle?.tipo, vehicle?.marcaModelo].filter(Boolean).join(" - "), vehicle?.dominio, vehicle?.poliza].forEach((v, i) =>
    field(v, [110, 321, 427][i], 385, [207, 102, 114][i], 11.5)
  );
  (d.residuos || []).forEach((r, row) => {
    const values = [r.contenedores, r.descripcion, `${r.cantidad ?? ""} ${r.unidad || ""}`, r.estadoFisico];
    values.forEach((v, i) => field(v, [110, 217, 321, 427][i], 432.5 + row * 13.4,
      [103, 100, 102, 114][i], 11.5));
  });
  field(d.componentes, 360, 507, 181, 11, false, 7);
  [["inhalacion", 543], ["dermica", 565], ["oral", 586]].forEach(([key, y]) =>
    field(typeof d[key] === "boolean" ? (d[key] ? "X" : "") : d[key],
      typeof d[key] === "boolean" ? 302 : 206, y,
      typeof d[key] === "boolean" ? 12 : 110, 18, false, 7)
  );
  [
    ["inflamabilidad", 422, 552],
    ["toxicidad", 403, 564],
    ["reactividad", 441, 564],
    ["instruccionesEspeciales", 422, 574],
  ].forEach(([key, x, y]) => {
    if (d[key] === true) {
      pdf.setFillColor(0);
      pdf.circle(x, y, 4.5, "F");
    } else if (d[key] !== false) {
      // Conserva la representación de manifiestos emitidos antes de las casillas.
      if (key !== "instruccionesEspeciales") field(d[key], x - 12, y - 6, 24, 10);
    }
  });
  if (typeof d.instruccionesEspeciales === "string")
    field(d.instruccionesEspeciales, 321, 598, 220, 8, false, 6);
  field([m.snapshot?.tratamiento?.descripcion, d.instruccionesOperador].filter(Boolean).join(". "),
    109, 630, 433, 24, true);
  const anexos = m.archivos || [];
  if (anexos.some((a) => a.tipo === "Contingencia"))
    field("X", 302, 671, 12, 11);
  if (anexos.some((a) => a.tipo !== "Contingencia"))
    field("X", 526, 671, 12, 11);
  if (!anexos.length) field(d.sinAnexos, 110, 685, 431, 11);
  field(d.telefonoOperador, 237, 713, 80, 11);
  field(d.telefonoTransportista, 452, 713, 89, 11);
  roles.forEach((rol, i) => {
    const actions = m.intervenciones || [];
    const entrega = actions.find((a) => a.rol === rol && a.accion === ({ Generador: "DESPACHO", Transportista: "TRASLADO", Operador: "RECEPCION" }[rol])) || actions.find((a) => a.rol === rol && a.accion === (rol === "Generador" ? "PRESENTAR" : "ACEPTAR"));
    const rechazo = actions.find((a) => a.rol === rol && a.accion === "RECHAZAR");
    const x = [216, 321, 427][i], width = [101, 102, 114][i];
    field(entrega?.caracter, x, 767, width, 11);
    field(entrega?.fecha, x, 780.5, width, 11);
    if (i > 0 && (rechazo || entrega)) field(rechazo ? "SI" : "NO", x, 794, width, 11, true);
  });
  field((m.intervenciones || []).filter((i) => i.accion === "RECHAZAR").map((i) => i.motivo).join(". "),
    216, 807, 325, 11);
  const cierre = m.intervenciones?.find((i) => i.accion === "CERRAR") || m.intervenciones?.find((i) => i.accion === "PRESENTAR");
  field(cierre?.usuario, 379, 854, 162, 14, Boolean(cierre));
  field(cierre?.fecha, 425, 879, 116, 11, Boolean(cierre));
  return pdf;
}
